import { render, staticRenderFns } from "./EditarProveedorModal.vue?vue&type=template&id=2231132d&"
import script from "./EditarProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./EditarProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports